<template>
  <div class="app-main-content">
    <div class="details-view" style="overflow: auto">
      <!--按钮-->
      <div v-if="!isDialog">
        <el-button v-if="isEdit" type="primary" no="Cancel" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-button v-if="isEdit" type="primary" no="Save" @click="save">{{ $t('CargoMsg.Cargo_SaveDraft') }}</el-button>
        <el-button v-if="isEdit" type="primary" no="Save" @click="publishDirectly">{{ $t('CargoMsg.Cargo_PublishDirectly') }}</el-button>
        <el-button v-if="!isEdit" type="primary" no="Back" @click="$emit('back')">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
        <el-button v-if="!look && !isEdit" :disabled="form.status === SystemConstants.PRICE_STATUS_NORMAL.code" type="primary" no="Edit" @click="edit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
      </div>
      <div class="main-content" style="width: fit-content; margin-top: 5px">
        <div style="display: flex">
          <!--基本信息-->
          <div class="section form-column" style="width: 900px">
            <el-form
              :disabled="!isEdit"
              label-width="140px"
              label-position="right"
            >
              <span class="title">{{ $t('CargoMsg.Cargo_BasicInfo') }}</span>
              <!--尾程运价编号-->
              <el-form-item :label="$t('CargoMsg.Cargo_EndRouteRateCode')">
                <el-input v-model="form.priceNo" disabled />
              </el-form-item>
              <!--              &lt;!&ndash;配送地址类型&ndash;&gt;-->
              <!--              <el-form-item :label="$t('CargoMsg.Cargo_DeliveryAddressType')" required>-->
              <!--                <el-radio-group v-model="form.deliveryAddressType" @change="deliveryAddressTypeChange">-->
              <!--                  <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_ThirdPartyAddress') }}</el-radio>-->
              <!--                  <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_AmazonWarehouse') }}</el-radio>-->
              <!--                  <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_ECANG.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_YiCang') }}</el-radio>-->
              <!--                </el-radio-group>-->
              <!--              </el-form-item>-->
              <!--              &lt;!&ndash;邮编&ndash;&gt;-->
              <!--              <el-form-item-->
              <!--                v-if="form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code"-->
              <!--                :label="$t('SeaExport.ZIP')"-->
              <!--                required-->
              <!--              >-->
              <!--                <cargo-post-code-select-->
              <!--                  :default-value="form.postalCode"-->
              <!--                  @change="postCodeChange"-->
              <!--                />-->
              <!--              </el-form-item>-->
              <!--              &lt;!&ndash;地址 由邮编中的城市，可编辑 &ndash;&gt;-->
              <!--              <el-form-item-->
              <!--                v-if="form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code"-->
              <!--                :label="$t('SeaExport.Addr')"-->
              <!--              >-->
              <!--                <el-input v-model="form.address" />-->
              <!--              </el-form-item>-->
              <!--              &lt;!&ndash;仓库代码&ndash;&gt;-->
              <!--              <el-form-item-->
              <!--                v-if="form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE.code ||-->
              <!--                  form.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_ECANG.code"-->
              <!--                :label="$t('CargoMsg.Cargo_WarehouseCode2')"-->
              <!--                required-->
              <!--              >-->
              <!--                <cargo-advance-select-->
              <!--                  no="overseaWarehouseCode"-->
              <!--                  :select-type="TYPE_NAMES.basic_data_OverseaWarehouse"-->
              <!--                  filterable-->
              <!--                  :method-params="{ifFba:true}"-->
              <!--                  :clearable="false"-->
              <!--                  tag-name="warehouseCode"-->
              <!--                  tag-value="warehouseCode"-->
              <!--                  :default-value="form.warehouseCode"-->
              <!--                  style="width:100%;"-->
              <!--                  @parentCallBack="p=>{form.warehouseCode=p.value}"-->
              <!--                />-->
              <!--              </el-form-item>-->
              <!--              <el-form :disabled="!isEdit" :inline="true" label-position="right" class="form-item-200">-->
              <el-form-item
                :label="$t('CargoMsg.Cargo_ShippingAddressSelection')"
                label-width="140px"
                required
              >
                <el-button v-if="isEdit" type="danger" @click="addArea">{{ $t('CargoMsg.Cargo_AddAddress') }}</el-button>
              </el-form-item>
              <div v-for="(priceRegion, index) in form.priceRegions" :key="index">
                <!--配送地址类型-->
                <el-form-item :label="$t('CargoMsg.Cargo_DeliveryAddressType')" required>
                  <el-radio-group v-model="priceRegion.deliveryAddressType" @change="deliveryAddressTypeChange(priceRegion)">
                    <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_ThirdPartyAddress') }}</el-radio>
                    <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_AmazonWarehouse') }}</el-radio>
                    <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_ECANG.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_YiCang') }}</el-radio>
                    <el-radio :label="SystemConstants.DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE.code" style="margin-right: 5px;">{{ $t('CargoMsg.Cargo_WalmartWarehouse') }}</el-radio>
                  </el-radio-group>
                  <i v-if="isEdit" style="color: #f56c6c; cursor: pointer; margin-top: 5px; font-size: 18px" class="el-icon-remove" @click="delArea(index)" />
                </el-form-item>
                <!--邮编-->
                <el-form-item
                  v-if="priceRegion.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code"
                  :label="$t('SeaExport.ZIP')"
                  required
                >
                  <cargo-post-code-select
                    :default-value="priceRegion.postalCode"
                    @change="p=>{postCodeChange(p, priceRegion)}"
                  />
                </el-form-item>
                <!--地址 由邮编中的城市，可编辑 -->
                <el-form-item
                  v-if="priceRegion.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code"
                  :label="$t('SeaExport.Addr')"
                >
                  <el-input v-model="priceRegion.address" />
                </el-form-item>
                <!--仓库代码-->
                <el-form-item
                  v-if="priceRegion.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_AMAZON_WAREHOUSE.code ||
                    priceRegion.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_ECANG.code ||
                    priceRegion.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_WALMART_WAREHOUSE.code"
                  :label="$t('CargoMsg.Cargo_WarehouseCode2')"
                  required
                >
                  <cargo-advance-select
                    no="overseaWarehouseCode"
                    :select-type="TYPE_NAMES.basic_data_OverseaWarehouse"
                    filterable
                    :method-params="{ifFba:true}"
                    :clearable="false"
                    tag-name="warehouseCode"
                    tag-value="warehouseCode"
                    :default-value="priceRegion.warehouseCode"
                    style="width:100%;"
                    @parentCallBack="p=>{priceRegion.warehouseCode=p.value}"
                  />
                </el-form-item>
                <el-form :disabled="!isEdit" :inline="true" label-position="right" class="form-item-200">
                  <div v-if="priceRegion.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code" style="display: flex; margin-top: 5px">
                    <cargo-area
                      no="area"
                      country="CN"
                      :province.sync="priceRegion.province"
                      :city.sync="priceRegion.city"
                      :district.sync="priceRegion.districts"
                      :town.sync="priceRegion.townUuid"
                      :show-town="true"
                      :select-width="150"
                      style="display: inline-block"
                    />
                  </div>
                </el-form>
              </div>
              <!--              </el-form>-->
            </el-form>
          </div>
          <!--目的港信息-->
          <div class="section form-column" style="width: 603px">
            <el-form
              :disabled="!isEdit"
              label-width="140px"
              label-position="right"
            >
              <span class="title">{{ $t('CargoMsg.Cargo_DestinationPortInfo') }}</span>
              <!--目的港-->
              <el-form-item :label="$t('CargoMsg.Cargo_POD')" required>
                <el-tabs v-model="form.portType" @tab-click="form.podList = []">
                  <el-tab-pane :disabled="!isEdit" :label="$t('CargoMsg.Cargo_Harbour')" :name="SystemConstants.PORT_TYPE_SEAPORT.code" />
                  <el-tab-pane :disabled="!isEdit" :label="$t('CargoMsg.Cargo_Airport')" :name="SystemConstants.PORT_TYPE_AIRPORT.code" />
                </el-tabs>
                <cargo-advance-select
                  v-if="form.portType === SystemConstants.PORT_TYPE_SEAPORT.code"
                  :select-type="TYPE_NAMES.basic_data_Seaport"
                  filterable
                  :default-multiple-value="form.podList"
                  :multiple="true"
                  style="width:100%"
                  @parentCallBack="p=>form.podList=p.value"
                />
                <cargo-advance-select
                  v-if="form.portType === SystemConstants.PORT_TYPE_AIRPORT.code"
                  :select-type="TYPE_NAMES.basic_data_Airport"
                  filterable
                  :default-multiple-value="form.podList"
                  :multiple="true"
                  style="width:100%"
                  @parentCallBack="p=>form.podList=p.value"
                />
              </el-form-item>
              <!--代理名称【指定货代理 或者 目的港代理 或者 卡车司机】-->
              <el-form-item :label="$t('FileHistory.ProxyName')">
                <cargo-company-select
                  ref="agentName"
                  no="agentName"
                  :method-params="{active:true, subCondition:{overseaAgent:true, designationAgent:true, truckCmp: true, collectionType: 'or'}}"
                  :default-value="form.agentName||''"
                  @change="p=>{form.agentName=p.value}"
                />
              </el-form-item>
              <!--有效期-->
              <el-form-item :label="$t('Pricing.BeginDate')" required>
                <el-date-picker
                  v-model="form.beginDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="{
                    disabledDate: time => {
                      return form.endDate && time.getTime() >= new Date(form.endDate.length <= 10 ? form.endDate + ' 00:00:00' : form.endDate).getTime()
                    }
                  }"
                />
                -
                <el-date-picker
                  v-model="form.endDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="{
                    disabledDate: time => {
                      return form.beginDate && time.getTime() <= new Date(form.beginDate.length <= 10 ? form.beginDate + ' 00:00:00' : form.beginDate).getTime()
                    }
                  }"
                />
              </el-form-item>
              <!--备注-->
              <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
                <el-input v-model="form.remarks" type="textarea" :rows="3" />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!--运价信息-->
        <div class="section" style="width:100%">
          <span class="title">{{ $t('Pricing.PriceInfo') }}</span>
          <!--按箱型计费条目-->
          <span>{{ $t('CargoMsg.Cargo_ChargeByContainerType') }}</span>
          <div v-if="isEdit" style="margin-top: 5px;">
            <el-button type="primary" @click="addChargingItem(SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button type="danger" @click="delChargingItem(SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid-wrapper
              config-module="2025050224"
              :grid-options="chargingItemByEqSize.gridOptions"
              :column-defs="getColumnDefsByEqSize"
              :row-data="form.byEqSizeChargingItems"
              :show-selected-color="false"
              :check-sub-record="false"
              style="height: 100%;"
              @gridReady="params=>{chargingItemByEqSize.gridApi=params.api}"
            />
          </div>
          <!--非按箱型计费条目-->
          <span>{{ $t('CargoMsg.Cargo_ChargeNotByContainerType') }}</span>
          <div v-if="isEdit" style="margin-top: 5px;">
            <el-button type="primary" @click="addChargingItem(SystemConstants.CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button type="danger" @click="delChargingItem(SystemConstants.CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code)">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
          <div class="section grid-wrapper">
            <cargo-ag-grid-wrapper
              config-module="2025050225"
              :grid-options="chargingItemNotByEqSize.gridOptions"
              :column-defs="getColumnDefsNotByEqSize"
              :row-data="form.notByEqSizeChargingItems"
              :show-selected-color="false"
              :check-sub-record="false"
              style="height: 100%;"
              @gridReady="params=>{chargingItemNotByEqSize.gridApi=params.api}"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- AI识别弹窗 -->
    <cargo-ai-recognition-dialog
      :visible.sync="aiRecognitionDialog.visible"
      :multimodal="aiRecognitionDialog.multimodal"
      :prompt-key="aiRecognitionDialog.promptKey"
      :call-back="aiRecognitionDialog.callBack"
      :title="$t('CargoMsg.CargoMsg_AIAddressRecognition')"
      :placeholder="aiRecognitionDialog.placeholder"
    />
  </div>
</template>

<script>
import cargoArea from '@/components/Cargo/Common/cargoArea'
import CargoAiRecognitionDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import PricePrePortLastMileDetail from './pricePrePortLastMileDetail'
import { PricePrePortLastMile } from '@/class/model/price/PricePrePortLastMile'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import cargoPostCodeSelect from '@/components/Cargo/Common/cargoPostCodeSelect'

export default {
  name: 'PriceLastMileDetail',
  components: { cargoArea, CargoAiRecognitionDialog, cargoAgGridWrapper, cargoAdvanceSelect, cargoCompanySelect, cargoPostCodeSelect },
  props: {
    look: { type: Boolean, default: false },
    isDialog: { type: Boolean, default: false } // 详情 是否 作为弹窗
  },
  data() {
    return {
      aiRecognitionDialog: {
        multimodal: false, // 多模态模式，true-多模态支持上传文件;false-仅文本上传
        callBack: null,
        promptKey: SystemConstants.DELIVERY_ADDRESS_PROMPT_KEY.code,
        visible: false
      },
      beginDatePickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledBeginDate
      },
      type: SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code,
      ColumnUtils,
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      chargingItemByEqSize: { // 按箱型计费条目
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.chargingItemByEqSize.selectedRows = this.chargingItemByEqSize.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.selectedRow = event.data
          },
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridCommonTextareaEditor
          }
        },
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      chargingItemNotByEqSize: { // 非按箱型计费条目
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
          suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          // 选中 勾选框触发
          onRowSelected: (event) => {
            this.chargingItemNotByEqSize.selectedRows = this.chargingItemNotByEqSize.gridApi.getSelectedRows()
          },
          onRowClicked: event => {
            this.selectedRow = event.data
          },
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          }
        },
        selectedRows: [],
        gridApi: null,
        filter: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      },
      isEdit: false, // 是否 编辑

      chargeItemSet: new Set(),
      form: new PricePrePortLastMile().fillDefaultValue().getData(),
      originForm: {}
    }
  },
  computed: {
    getColumnDefsByEqSize() {
      return this.getChargingItemByEqSizeDefs()
    },
    getColumnDefsNotByEqSize() {
      return this.getChargingItemNotByEqSizeDefs()
    }
  },
  created() {
    this.init()
  },
  methods: PricePrePortLastMileDetail.methods
}
</script>

<style scoped lang="scss">
</style>
